import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import Context from '../../../utils/context';

import styles from './index.module.css';

export default function SimpleHeader({
  logoClickable,
  openInNewTab,
  logo = false,
  showLogin = true,
  isSticky = true,
  returnTo,
  color = '#59b6be',
}) {
  const context = useContext(Context);
  const isLoggedIn = context.auth.isLoggedIn();

  const renderLogo = () => {
    return (
      <>
        <img
          className={styles.logo}
          alt='logo'
          id='logo'
          src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/PatientPartner+Logo_Teal.png'
        />
      </>
    );
  };

  return (
    <header id={isSticky ? 'hdr-content' : ''}>
      <div className={`container`}>
        <div className='row'>
          <div className='col-10'>
            <div className={styles.hdr_logo_lg}>
              {logo && (
                <>
                  <img className={styles.customer_logo} src={logo} alt='logo' />
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                    className={styles.plus_icon}
                  >
                    <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                    <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round'></g>
                    <g id='SVGRepo_iconCarrier'>
                      <path
                        d='M6 12H18M12 6V18'
                        stroke={color}
                        strokeWidth='3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      ></path>
                    </g>
                  </svg>
                </>
              )}

              {logoClickable ? (
                openInNewTab ? (
                  <a target='_blank' href='https://www.patientpartner.com/'>
                    {renderLogo()}
                  </a>
                ) : (
                  <a href='/'>{renderLogo()}</a>
                )
              ) : (
                renderLogo()
              )}
            </div>
          </div>

          <div className='col-2 d-flex justify-content-end align-items-center'>
            {!isLoggedIn && showLogin && (
              <Link to={`/member/login?returnTo=${returnTo}`}>
                <button className={styles.login_btn} style={{ backgroundColor: color }}>
                  Login
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
